import type { ReactNode } from 'react'

interface PageLayoutProps {
  /** Page title shown in the sticky header */
  readonly title: string
  /** Main content area */
  readonly children: ReactNode
  /** Optional footer pinned below the main content */
  readonly footer?: ReactNode
  /** Extra content rendered inside the header, below the title (e.g. search bar, filters) */
  readonly headerExtra?: ReactNode
  /** Extra class names on the <main> element */
  readonly contentClassName?: string
}

/**
 * Standard page shell: sticky header + scrollable main + optional footer.
 * Applies Telegram theme colors and bottom-nav clearance (pb-20) automatically.
 */
export function PageLayout({
  title,
  children,
  footer,
  headerExtra,
  contentClassName = '',
}: PageLayoutProps) {
  return (
    <div className="flex min-h-dvh flex-col bg-tg-bg">
      <header
        className="sticky top-0 z-10 shrink-0 px-4 py-3 bg-tg-bg"
        style={{
          borderBottom: '1px solid color-mix(in srgb, var(--tg-theme-hint-color) 10%, transparent)',
          boxShadow: '0 1px 3px 0 color-mix(in srgb, var(--tg-theme-hint-color) 8%, transparent)',
        }}
      >
        <h1 className="text-lg font-semibold text-tg-text">
          {title}
        </h1>
        {headerExtra}
      </header>
      <main className={`flex-1 px-4 pt-4 pb-20 ${contentClassName}`}>
        {children}
      </main>
      {footer}
    </div>
  )
}
